module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "duration": 1000
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-12 col-md-offset-5",
    staticStyle: {
      "position": "absolute",
      "top": "0"
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh fa-spin fa-2x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])]), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "disabled"
  }, [_c('h3', {
    staticClass: "text-primary",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('em', [_vm._v(_vm._s(_vm.carehomeDto.name))])])]), _vm._v(" "), _c('li', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.CreateUser($event)
      }
    }
  }, [_vm._v("Add User")])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('carehome-user-table', {
    attrs: {
      "id": _vm.carehomeid
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5fc44471", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fc44471"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/pages/pharmacy/carehome-users.scp.html
// module id = 550
// module chunks = 0